<template>
    <div class="investigative-action">
        <Row class="detail-header">
            <span>侦查行动</span>
            <Button class="add-btn" v-if="infoCtrl&&isDetailLoad" type="primary" @click="infoCtrl=false">修改</Button>
        </Row>
        <Row class="case-content">
            <Row v-if="!infoCtrl&&isDetailLoad">
                <Form ref="formData" class="case-form" :model="formData" :rules="ruleValidate" :label-width="100">
                    <FormItem label="行动时间" prop="investigateDate">
                        <DatePicker 
                                transfer 
                                type="date" 
                                placeholder="请选择行动时间" 
                                style="width:100%" 
                                format="yyyy-MM-dd" 
                                :value="formData.investigateDate"
                                @on-change="getTime"></DatePicker>
                    </FormItem>
                    <FormItem label="结果" prop="results">
                        <Input v-model="formData.results" type="textarea" :autosize="{minRows: 3,maxRows: 10}" placeholder="请输入查处产品/查扣数量/案值"></Input>
                    </FormItem>
                    <FormItem label="查处主体" prop="subject">
                        <Input v-model="formData.subject" placeholder="请输入查处主体"></Input>
                    </FormItem>
                    <FormItem label="查处当事人" prop="litigant">
                        <Input v-model="formData.litigant" placeholder="请输入查处当事人"></Input>
                    </FormItem>
                    <FormItem label="查处地址" prop="address">
                        <Input v-model="formData.address" placeholder="请输入查处地址"></Input>
                    </FormItem>
                    <FormItem label="执法部门" prop="lawEnforcement">
                        <Input v-model="formData.lawEnforcement" placeholder="请输入执法部门"></Input>
                    </FormItem>
                    <FormItem label="执法联系人" prop="lawEnforcementContact">
                        <Input v-model="formData.lawEnforcementContact" placeholder="请输入执法联系人"></Input>
                    </FormItem>
                    <FormItem label="执法地址" prop="lawEnforcementAddress">
                        <Input v-model="formData.lawEnforcementAddress" placeholder="请输入执法地址"></Input>
                    </FormItem>
                    <FormItem label="行动文件" prop="attachmentList">
                        <file-upload
                                :defaultList="defaultList || []" 
                                :uploadConfig="{}"
                                @getFileList="getAttachmentList"></file-upload>
                    </FormItem>
                    <FormItem label="构成刑事" prop="isCriminal">
                        <RadioGroup v-model="formData.isCriminal">
                            <Radio :disabled="defaultData?true:false" :label="1">是</Radio>
                            <Radio :disabled="defaultData?true:false" :label="0">否</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem v-if="formData.isCriminal===0" label="情况说明" prop="remark">
                        <Input v-model.trim="formData.remark" type="textarea" :autosize="{minRows: 3,maxRows: 8}" placeholder='请填写情况说明'></Input>
                    </FormItem>
                </Form>
                <Row class="detail-btn-box">
                    <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="submitNew">保存</Button>
                    <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
                </Row>
            </Row>
            <Row class="detail-content" v-if="infoCtrl&&isDetailLoad">
                <Row><Col span="5" class="left-label">行动时间：</Col><Col span="16" class="right-content">{{defaultData.investigateDate}}</Col></Row>
                <Row><Col span="5" class="left-label">结果：</Col><Col span="16" class="right-content">{{defaultData.results}}</Col></Row>
                <Row><Col span="5" class="left-label">查处主体：</Col><Col span="16" class="right-content">{{defaultData.subject}}</Col></Row>
                <Row><Col span="5" class="left-label">查处当事人：</Col><Col span="16" class="right-content">{{defaultData.litigant}}</Col></Row>
                <Row><Col span="5" class="left-label">查处地址：</Col><Col span="16" class="right-content">{{defaultData.address}}</Col></Row>
                <Row><Col span="5" class="left-label">执法部门：</Col><Col span="16" class="right-content">{{defaultData.lawEnforcement}}</Col></Row>
                <Row><Col span="5" class="left-label">执法联系人：</Col><Col span="16" class="right-content">{{defaultData.lawEnforcementContact}}</Col></Row>
                <Row><Col span="5" class="left-label">执法地址：</Col><Col span="16" class="right-content">{{defaultData.lawEnforcementAddress}}</Col></Row>
                <Row>
                    <Col span="5" class="left-label">行动文件：</Col>
                    <Col span="16" class="right-content">
                        <file-upload
                                :defaultList="defaultData.attachmentList || []" 
                                :uploadConfig="{readOnly:true}"></file-upload>
                    </Col>
                </Row>
                <Row><Col span="5" class="left-label">构成刑事：</Col><Col span="16" class="right-content">{{defaultData.isCriminal?"是":"否"}}</Col></Row>
                <Row v-if="!defaultData.isCriminal"><Col span="5" class="left-label">情况说明：</Col><Col span="16" class="right-content">{{defaultData.remark}}</Col></Row>
            </Row>
        </Row>
    </div>
</template>
<script>
export default {
    data () {
        return {
            isDetailLoad:false,
            infoCtrl:true,
            isSubmit:false,
            defaultData:"",
            defaultList:[],
            litigantIdArr:[],
            formData:{
                investigateDate:"",
                results:"",
                subject:"",
                litigant:"",
                investigationAddress:"",
                lawEnforcement:"",
                lawEnforcementContact:"",
                lawEnforcementAddress:"",
                attachmentList:[],
                isCriminal:1,
                remark:""
            },
            ruleValidate:{
                investigateDate:[{ required: true, message: '行动时间不能为空', trigger: 'blur' }],
                results:[{ required: true, message: '结果不能为空', trigger: 'blur' },{ max:1024,message:'不能超过1024个字符',trigger:'blur' }],
                subject:[{ required: true, message: '查处主体不能为空', trigger: 'blur' },{ max:128,message:'不能超过128个字符',trigger:'blur' }],
                litigant:[{ required: true, message: '查处当事人不能为空', trigger: 'blur' },{ max:128,message:'不能超过128个字符',trigger:'blur' }],
                address:[{ required: true, message: '查处地址不能为空', trigger: 'blur' },{ max:256,message:'不能超过256个字符',trigger:'blur' }],
                lawEnforcement:[{ required: true, message: '执法部门不能为空', trigger: 'blur' },{ max:64,message:'不能超过64个字符',trigger:'blur' }],
                lawEnforcementContact:[{ required: true, message: '执法联系人不能为空', trigger: 'blur' },{ max:32,message:'不能超过32个字符',trigger:'blur' }],
                lawEnforcementAddress:[{ required: true, message: '执法地址不能为空', trigger: 'blur' },{ max:256,message:'不能超过256个字符',trigger:'blur' }],
                attachmentList:[{ required: true,type:"array", message: '行动文件不能为空', trigger: 'blur' }],
                isCriminal:[{ required: true,type:"number", message: '构成刑事不能为空', trigger: 'blur' }]
            }
        }
    },
    props: ['processId','caseId'],
    methods: {
        getDetail(){
            let url = '/business/case/criminal/investigation?processId='+this.processId;
            this.$get(url).then(res=>{
                if(res.code==0&&res.data){
                    this.defaultData = res.data;
                    this.infoCtrl = true;
                    this.giveDefaultData();
                }else{
                    this.defaultData = "";
                    this.infoCtrl = false;
                    this.isDetailLoad = true;
                }
            });
        },
        getTime(value){
            this.formData.investigateDate = value;
        },
        getAttachmentList(arr){
            this.formData.attachmentList = [];
            arr.forEach((item,index)=>{
                let obj = {
                    fileName:item.fileName,
                    mediaType:item.mediaType,
                    smallUrl:item.smallUrl,
                    url:item.url
                }
                if(item.id){ obj.id = item.id; }
                this.formData.attachmentList.push(obj);
            })
        },
        giveDefaultData(){
            this.formData.investigateDate = this.defaultData.investigateDate;
            this.formData.results = this.defaultData.results;
            this.formData.subject = this.defaultData.subject;
            this.formData.litigant = this.defaultData.litigant;
            this.formData.address = this.defaultData.address;
            this.formData.investigationAddress = this.defaultData.investigationAddress;
            this.formData.lawEnforcement = this.defaultData.lawEnforcement;
            this.formData.lawEnforcementContact = this.defaultData.lawEnforcementContact;
            this.formData.lawEnforcementAddress = this.defaultData.lawEnforcementAddress;
            this.formData.isCriminal = this.defaultData.isCriminal?1:0;
            this.formData.remark = this.defaultData.remark;

            this.formData.attachmentList = this.defaultData.attachmentList;
            this.defaultList = this.defaultData.attachmentList;

            this.isDetailLoad = true;
        },
        submitNew(){
            let url = "/business/case/criminal/investigation";
            let ajaxData = {
                processId:this.processId,
                caseId:this.caseId
            }
            Object.assign(ajaxData,this.formData);
            if(this.defaultData){
                ajaxData.id = this.defaultData.id;
                this.$refs['formData'].validate((valid) => {
                    if(valid){
                        this.isSubmit = true;
                        this.$patch(url,ajaxData).then(res=>{
                            this.isSubmit = false;
                            if(res.code==0){
                                this.getDetail();
                                this.$Message.success("操作成功");
                                this.$emit('reloadProcess');
                            }else{
                                this.$Message.error(res.message);
                            }
                        })
                    }
                })
            }else{
                this.$refs['formData'].validate((valid) => {
                    if(valid){
                        this.isSubmit = true;
                        this.$post(url,ajaxData).then(res=>{
                            this.isSubmit = false;
                            if(res.code==0){
                                this.$Message.success("操作成功");
                                this.$emit('reloadProcess');
                            }else{
                                this.$Message.error(res.message);
                            }
                        })
                    }
                })
            }
        }
    },
    created(){},
    beforeMount(){},
    mounted(){
        this.getDetail();
    },
    updated(){},
    components: {},
    watch: {}
}
</script>
<style lang="scss" scoped>
@import '../../civilCase/caseCommon.scss';
</style>



// WEBPACK FOOTER //
// src/view/criminalCase/investigativeAction/index.vue